<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" :width="'80%'" />

    <a-form-model
      :model="form"
      ref="form"
      :label-col="{ span: 3 }"
      :rules="rules"
      :wrapper-col="{ span: 10 }"
      class="padding-lr"
    >
      <a-tabs tab-position="top" v-model="tabIndex">
        <!-- 基础信息 -->
        <a-tab-pane :key="1" tab="基础信息">
          <a-row :gutter="12">
            <a-col :span="24">
              <a-form-model-item label="商品分类" prop="shopCategoryId" class="margin-bottom-10">
                <a-select
                  show-search
                  :allowClear="true"
                  v-model="form.shopCategoryId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  @popupScroll="handlePopupScroll"
                >
                  <a-select-option v-for="d in cateList" :key="d.categoryId">{{ d.categoryName }}</a-select-option>
                </a-select>
              </a-form-model-item>

              <a-form-model-item label="商品名称" prop="prodName" class="margin-bottom-10">
                <a-input v-model="form.prodName" placeholder="请输入" />
              </a-form-model-item>

              <a-form-model-item label="标签显示" prop="tagHide">
                <a-radio-group v-model="form.tagHide" button-style="solid">
                  <a-radio-button
                    :value="0"
                    :class="{ 'active-bg': form.tagHide === 0 }"
                    :style="{ backgroundColor: form.tagHide === 0 ? '#52c41a' : '' }"
                  >
                    无
                  </a-radio-button>
                  <a-radio-button
                    :value="1"
                    :class="{ 'active-bg': form.tagHide === 1 }"
                    :style="{ backgroundColor: form.tagHide === 1 ? '#ff4d4f' : '' }"
                  >
                    有
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>

              <template v-if="form.tagHide == 1">
                <a-form-model-item label="标签名称" prop="tagTitle">
                  <a-input v-model="form.tagTitle" placeholder="请输入" />
                </a-form-model-item>
                <a-form-model-item label="标签颜色" prop="tagType">
                  <el-color-picker v-model="form.tagType" @change="handleColorPickerChange"></el-color-picker>
                </a-form-model-item>
              </template>

              <a-form-model-item label="商品主图" prop="pic">
                <file-upload
                  type="image"
                  :defaultList="Array.isArray(form.pic) ? form.pic : [form.pic].filter(Boolean)"
                  @input="getImg($event, 'pic')"
                  :file="form.pic"
                  :count="1"
                  :autoCropHeight="210"
                  :autoCropWidth="164"
                ></file-upload>
              </a-form-model-item>

              <a-form-model-item label="商品图集" prop="fileImgs">
                <file-upload
                  type="image"
                  :defaultList="form.fileImgs"
                  @input="getImg($event, 'fileImgs')"
                  :file="form.fileImgs"
                  :count="6"
                  :autoCropHeight="350"
                  :autoCropWidth="350"
                ></file-upload>
              </a-form-model-item>

              <a-form-model-item label="商品简述" prop="brief">
                <a-input
                  v-model="form.brief"
                  type="textarea"
                  placeholder="请输入"
                  :maxLength="500"
                  allow-clear
                  :auto-size="{ minRows: 8 }"
                />
              </a-form-model-item>

              <div v-if="form.isVideo">
                <a-form-model-item label="视频类型" class="margin-bottom-10" prop="video">
                  <a-radio-group v-model="form.videoType" button-style="solid" @change="changeVideo">
                    <a-radio-button :value="1"> 本地视频 </a-radio-button>
                    <a-radio-button :value="2"> 视频链接 </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="12">
                    <file-upload
                      v-if="form.videoType === 1"
                      type="video"
                      :defaultList="form.video"
                      @input="getImg($event, 'video')"
                      :file="form.video"
                      :count="1"
                      :autoCropHeight="350"
                      :isUpload="false"
                      :autoCropWidth="750"
                    ></file-upload>
                    <div v-if="form.videoType === 2" style="height: 93px; padding-top: 20px">
                      <a-input placeholder="请输入视频链接" v-model="form.video"></a-input>
                    </div>
                  </a-col>
                </a-row>
              </div>

              <a-divider></a-divider>
              <a-row style="margin: 30px 0">
                <a-col :span="2"></a-col>
                <a-col :span="12" class="margin-tb-lg">
                  <a-button type="primary" size="large" @click="changeTab(1, 'next')">下一步</a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-tab-pane>

        <!-- 规格库存 -->
        <a-tab-pane :key="2" tab="规格库存">
          <a-button type="primary" size="small" @click="handleShopAdd" class="margin-left-sm margin-right">
            添加
          </a-button>
          <a-table :columns="columns" :data-source="sortedSkuList" rowKey="index" :pagination="false">
            <div slot="skuName" slot-scope="text, record">
              <a-input placeholder="请输入" v-model="record.skuName" />
            </div>
            <div slot="pic" slot-scope="text, record, index">
              <file-upload
                type="image"
                :defaultList="Array.isArray(record.pic) ? record.pic : [record.pic].filter(Boolean)"
                :file="record.pic"
                @input="getImgs($event, index)"
                :count="1"
                autoCropHeight="80"
                :isUpload="false"
                autoCropWidth="80"
              ></file-upload>
            </div>
            <div slot="price" slot-scope="text, record">
              <a-input placeholder="请输入" v-model="record.price" />
            </div>
            <div slot="modelId" slot-scope="text, record">
              <a-input placeholder="请输入" v-model="record.modelId" />
            </div>
            <div slot="sort" slot-scope="text, record">
              <a-input-number
                size="small"
                :min="0"
                :precision="0"
                :value="record.sort"
                @change="(val) => handleSortChange(val, record)"
              />
            </div>
            <div slot="unit" slot-scope="text, record">
              <a-input placeholder="请输入" v-model="record.unit" />
            </div>
            <div slot="recommendPrice" slot-scope="text, record">
              <a-input placeholder="请输入" v-model="record.recommendPrice" />
            </div>
            <div slot="oriPrice" slot-scope="text, record">
              <a-input placeholder="请输入" v-model="record.oriPrice" />
            </div>
            <div slot="status" slot-scope="text, record">
              <a-radio-group v-model="record.status" button-style="solid" size="small">
                <a-radio-button :value="0"> 禁用 </a-radio-button>
                <a-radio-button :value="1"> 启用 </a-radio-button>
              </a-radio-group>
            </div>
            <div slot="operation" slot-scope="text, record, index">
              <a-button type="danger" size="small" @click="ondelete(index)" class="margin-left-sm margin-right">
                删除
              </a-button>
            </div>
          </a-table>

          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="changeTab(2, 'back')" size="large" class="margin-right">上一步</a-button>
              <a-button @click="changeTab(2, 'next')" type="primary" size="large">下一步</a-button>
            </a-col>
          </a-row>
        </a-tab-pane>

        <!-- 其他设置 -->
        <a-tab-pane :key="3" tab="其他设置">
          <a-form-model-item label="商品详情" prop="content" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <editor v-model="form.content" />
          </a-form-model-item>

          <a-divider></a-divider>
          <a-row style="margin: 30px 0">
            <a-col :span="2"></a-col>
            <a-col :span="12" class="margin-tb-lg">
              <a-button @click="submitForm" type="primary" size="large">保存</a-button>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-form-model>
  </a-drawer>
</template>

<script>
import elColorPicker from 'el-color-picker'
import { getObj, addObj, putObj, fetchList2 } from '@/api/declaration/productDeclaration'
import editor from '@/components/Editor/Editor.vue'

export default {
  name: 'CreateForm',
  components: { editor, elColorPicker },
  data() {
    return {
      tabIndex: 1,
      formTitle: '',
      form: {
        tagType: '#EEE',
        id: undefined,
        shopCategoryId: undefined,
        content: undefined,
        fileImgs: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        scorePrice: 0,
        sort: 99,
        totalStocks: undefined,
        video: undefined,
        isSpec: 0,
        goldBeansPrice: 0,
        isRecommend: true,
        videoType: 1,
        tagHide: 0,
      },
      columns: [
        {
          title: '条形码',
          dataIndex: 'modelId',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'modelId' },
        },
        {
          title: 'sku名称',
          dataIndex: 'skuName',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'skuName' },
        },
        { title: 'sku图片', dataIndex: 'pic', align: 'center', scopedSlots: { customRender: 'pic' } },
        { title: '原价', dataIndex: 'oriPrice', align: 'center', scopedSlots: { customRender: 'oriPrice' } },
        { title: '价格', dataIndex: 'price', align: 'center', scopedSlots: { customRender: 'price' } },
        {
          title: '建议价格',
          dataIndex: 'recommendPrice',
          align: 'center',
          scopedSlots: { customRender: 'recommendPrice' },
        },
        { title: '单位', dataIndex: 'unit', align: 'center', scopedSlots: { customRender: 'unit' } },
        {
          title: '排序',
          dataIndex: 'sort',
          align: 'center',
          width: 90,
          sorter: (a, b) => a.sort - b.sort,
          scopedSlots: { customRender: 'sort' },
        },
        { title: '状态', dataIndex: 'status', align: 'center', width: 120, scopedSlots: { customRender: 'status' } },
        {
          title: '操作',
          dataIndex: 'operation',
          align: 'center',
          width: 70,
          scopedSlots: { customRender: 'operation' },
        },
      ],
      dataSku: [],
      cateList: [],
      queryParam: { pageNum: 1, pageSize: 1000, grade: 3 },
      rules: {
        tagTitle: [{ required: true, message: '请输入标签名称', trigger: 'blur' }],
        tagType: [{ required: true, message: '请选择标签颜色', trigger: 'blur' }],
        goldBeansPrice: [{ required: true, message: '请输入商品金豆', trigger: 'blur' }],
        totalStocks: [{ required: true, message: '请输入总库存', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        cateId: [{ required: true, message: '请选择文章分类', trigger: 'blur' }],
        prodName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        oriPrice: [{ required: true, message: '请输入商品价值', trigger: 'blur' }],
        fileImgs: [{ required: true, message: '请上传商品相册', trigger: 'blur' }],
        shopCategoryId: [{ required: true, message: '请选择商品分类', trigger: 'blur' }],
        brief: [{ required: true, message: '请输入商品简介', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传商品主图', trigger: 'blur' }],
        scorePrice: [{ required: true, message: '请输入商品积分', trigger: 'blur' }],
        content: [{ required: true, message: '请输入商品详情', trigger: 'blur' }],
      },
      loading: false,
      submitLoading: false,
      showLoading: false,
      isVideo: false,
      curSpec: undefined,
      isShowSpec: false,
      open: false,

      // 【新增】SKU 各字段校验规则
      skuRules: {
        skuName: { required: true, message: '请输入SKU名称', trigger: ['blur', 'change'] },
        pic: { required: true, message: '请上传SKU图片', trigger: 'change' },
        modelId: { required: true, message: '请输入条形码', trigger: ['blur', 'change'] },
        price: {
          required: true,
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '价格须为数字(最多两位小数)',
          trigger: ['blur', 'change'],
        },
        oriPrice: {
          required: true,
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '原价须为数字(最多两位小数)',
          trigger: ['blur', 'change'],
        },
        recommendPrice: {
          required: true,
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '建议价格须为数字(最多两位小数)',
          trigger: ['blur', 'change'],
        },
        unit: { required: true, message: '请输入单位', trigger: ['blur', 'change'] },
        sort: { required: true, pattern: /^\d+$/, message: '排序须为非负整数', trigger: ['blur', 'change'] },
        status: { required: true, type: 'number', message: '请选择状态', trigger: 'change' },
      },
    }
  },
  computed: {
    sortedSkuList() {
      return [...this.dataSku].sort((a, b) => a.sort - b.sort)
    },
  },
  created() {
    this.getCateList()
  },
  methods: {
    // 【新增】整表校验 dataSku
    validateSkuList() {
      let valid = true
      this.dataSku.forEach((row, idx) => {
        Object.keys(this.skuRules).forEach((key) => {
          const rule = this.skuRules[key]
          const val = row[key]
          if (!val || (Array.isArray(val) && val.length === 0)) {
            this.$message.error(`${rule.message}`)
            valid = false
            return false
          }
          if (rule.pattern && !rule.pattern.test(val)) {
            this.$message.error(`${rule.message}`)
            valid = false
            return false
          }
        })
      })
      return valid
    },

    handleSortChange(val, row) {
      row.sort = val
      this.dataSku = [...this.dataSku]
    },
    handleColorPickerChange(color) {
      this.form.tagType = color
    },
    getCateList() {
      if (this.loading) return
      this.loading = true
      fetchList2(this.queryParam)
        .then((res) => {
          if (this.queryParam.pageNum === 1) {
            this.cateList = res.data.records
          } else {
            this.cateList = [...this.cateList, ...res.data.records]
          }
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onClose() {
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk: () => {
          this.open = false
        },
      })
    },
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    getImgs(info, index) {
      this.dataSku[index].pic = info
      this.$set(this.dataSku, index, { ...this.dataSku[index] })
    },
    ondelete(index) {
      this.dataSku.splice(index, 1)
      this.dataSku = [...this.dataSku]
    },
    handleShopAdd() {
      const maxSort = this.dataSku.reduce((max, item) => {
        const n = Number(item.sort)
        return n > max ? n : max
      }, 0)
      this.dataSku.push({
        skuName: undefined,
        sort: maxSort + 1,
        status: 1,
        recommendPrice: undefined,
        price: undefined,
        oriPrice: undefined,
        modelId: undefined,
        unit: undefined,
        pic: null,
        index: Date.now(),
      })
      this.dataSku = [...this.dataSku]
    },
    changeVideo(e) {
      this.isVideo = e.target.value === 1
    },
    changeTab(index, type) {
      if (type === 'next') {
        if (index === 1) {
          const fields = ['shopCategoryId', 'prodName', 'brief', 'pic', 'fileImgs']
          let count = 0
          let ok = true
          fields.forEach((f) => {
            this.$refs.form.validateField(f, (err) => {
              count++
              if (err) ok = false
              if (count === fields.length && ok) this.tabIndex += 1
            })
          })
        } else if (index === 2) {
          if (!this.validateSkuList()) return // 【新增】
          this.form.sdkParams = this.dataSku
          this.tabIndex += 1
        }
      } else {
        this.tabIndex -= 1
      }
    },
    handleAdd(e) {
      this.tabIndex = 1
      this.reset()
      this.open = true
      if (e) this.form.shopCategoryId = e
      this.formTitle = '添加商品'
    },
    handleUpdate(row, ids) {
      this.tabIndex = 1
      this.reset()
      const id = row ? row.prodId : ids
      getObj(id).then((res) => {
        this.form = res.data
        this.form.isSpec = 0
        this.dataSku = res.data.skuList || []
        this.open = true
        this.formTitle = '修改商品'
      })
    },
    submitForm() {
      if (!this.validateSkuList()) return // 【新增】
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        this.showLoading = true
        this.$nextTick(() => this.$refs.LoadingPop.init(1))
        const action = this.form.prodId ? putObj(this.form) : addObj(this.form)
        action
          .then(() => {
            this.$message.success(this.form.prodId ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
            this.showLoading = false
          })
      })
    },
    reset() {
      this.form = {
        tagType: '#EEE',
        id: undefined,
        shopCategoryId: undefined,
        content: undefined,
        fileImgs: [],
        oriPrice: undefined,
        pic: undefined,
        prodName: undefined,
        prodType: 0,
        remark: undefined,
        scorePrice: 0,
        sort: 99,
        totalStocks: undefined,
        video: undefined,
        isSpec: 0,
        goldBeansPrice: 0,
        isRecommend: true,
        videoType: 1,
        tagHide: 0,
      }
      this.dataSku = []
    },
    handlePopupScroll(e) {
      const { target } = e
      const scrollHeight = target.scrollHeight - target.scrollTop
      const clientHeight = target.clientHeight
      if (scrollHeight < clientHeight + 5 && this.hasMoreData() && !this.loading) {
        this.queryParam.pageNum += 1
        this.getCateList()
      }
    },
    hasMoreData() {
      return this.cateList.length < this.total
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())
    },
    onCloseConfirm(callback) {
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk: callback,
        onCancel: () => {},
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.ant-tabs-tab {
  border: none !important;
  padding-top: 0 !important;
}
.ant-tabs-bar {
  border: none !important;
  box-shadow: none !important;
  height: 45px !important;
  padding-top: 5px !important;
}
::v-deep .ant-radio-button-wrapper {
  transition: all 0.3s;
}
.ant-radio-button-wrapper.active-bg {
  color: white !important;
}
</style>
